<aside class="secondary-sidepanel secondary-sidepanel--bug-report" *ngIf="navService.getBugReportPane()"
  data-html2canvas-ignore="true">
  <!-- <div class="footer-sidepanel__header">
    <h5>Support Feedback</h5>
    <a  (click)="closeForm()"><i class="fa-light fa-xmark"></i></a>
  </div> -->
  <div class="footer-sidepanel__content" @openClose>
    <!-- Hiding attachment -->
    <div class="icon-based-tabs-wrapper">
      <div class="icon-based-tabs icon-based-tabs--footer-tabs">
        <ul class="icon-based-tabs__content">
          <li><a  class="active"><i class="fa-solid fa-bug"></i><span>Problem</span></a>
          </li>
          <!-- <li><a ><i class="fa-solid fa-hand-back-point-up"></i><span>Suggest</span></a>
          </li>
          <li><a ><i class="fa-solid fa-question"></i><span>Question</span></a>
          </li>
          <li><a ><i class="fa-solid fa-heart"></i><span>Appreciate</span></a>
          </li> -->
        </ul>
      </div>
    </div>

    <form [formGroup]="bugReportService.bugReportForm" class="support-form" (ngSubmit)="submitBugReport()">
      <div class="flex-row">
        <div class="flex-col-sm-7">
          <div class="single-input-field-wrapper">
            <div class="dropdown-list-wrapper">
              <div class="dropdown-list">
                <label></label>
                <f-dropdown formControlName="bugType" [filter]="true" placeholder="Select Severity"
                  [options]="bugReportService.bugsType" optionLabel="name" optionValue="code"
                  [ngStyle]="{ width: '100%' }" [style]="{ width: '100%' }">
                </f-dropdown>
              </div>
            </div>

            <div class="validation validation--error validation--push-bottom pb-5"
              *ngIf="bugReportService.checkFieldValidation('bugType')">
              Please provide bug type.
            </div>
          </div>
        </div>
        <div class="flex-col-sm-12">

          <div class="single-input-field-wrapper single-input-field-wrapper--revised">
            <div class="form-fields">

              <input formControlName="subject" type="text" placeholder="Subject" class="form-fields__input">
            </div>
            <div class="validation validation--error validation--push-bottom"
              *ngIf="bugReportService.checkFieldValidation('subject')">
              Please provide subject.
            </div>
          </div>

        </div>
        <div class="flex-col-sm-12">
          <div class="single-input-field-wrapper single-input-field-wrapper--revised">
            <div class="form-fields">
              <textarea formControlName="description" name="" id="" cols="30" rows="10" placeholder="Describe problem"
                class="form-fields__textarea"></textarea>
            </div>
            <div *ngIf="bugReportService.checkFieldValidation('description')"
              class="validation validation--error validation--push-bottom">Please provide description.
            </div>
          </div>
        </div>
        <div class="flex-col-sm-12">
          <div class="actions-grp">
            <a style="pointer-events: none;" (click)="bugReportService.checkMaxFileSelections() && fileInput.click()" >
               <!-- Hiding attachment -->
              <!-- <i class="fa-light fa-paperclip-vertical"> <input style="display: 'none'"
                  type="file" accept="image/*" (change)="onFilesSelect($event)" #fileInput>
                </i> -->
                <i > <input style="display: none"
                  type="file" accept="image/*" (change)="onFilesSelect($event)" #fileInput>
                </i>
                </a>
            <div class="btns-group">
              <button type='button'(click)="closeForm()"  class="btns-group__btn">Discard</button>
              <button type="submit" class="btns-group__btn btns-group__btn--with-bg">Send</button>
            </div>
          </div>
        </div>

        <div class="flex-col-sm-12">
          <div class="warning-message"><span>Note: </span>Some of your account and system information will
            be
            included along with your feedback.</div>
        </div>
        <div class="flex-col-sm-12">
          <ul>
            <li *ngFor="let item of bugReportService.externalSelectedImages; let currentElementIndex=index">
               {{currentElementIndex + 1}}: {{item.Title}}
               <a  (click)="bugReportService.removeExternalImage(currentElementIndex)"><i class="fa-light fa-xmark ml-20"></i></a>
            </li>
           
         </ul>
        </div>
        <div *ngIf="!bugReportService.checkMaxFileSelections()" class="flex-col-sm-12">
          <div class="warning-message"><span>Warning: </span>Max upload Size of (2) Reached!</div>
        </div>
      </div>
    </form>

  </div>
</aside>